import { form } from '../../formState'
import { useTexts } from '../../hooks/useTexts'

const FOUR_HOURS_IN_SECONDS = 4 * 60 * 60

export function AdditionalDrivingTime() {
  const type = form.useFormField('type')
  const texts = useTexts()

  form.useAddFieldValidation<'additionalDrivingTimeSec'>(
    'additionalDrivingTimeSec',
    (field, formApi) => {
      const type = formApi.getField('type')?.value

      if (type === 'delayed') {
        if (field.value <= 0) {
          return texts.errorAdditionalDrivingTimeSecGreaterThanZero
        }
        if (field.value > FOUR_HOURS_IN_SECONDS) {
          return texts.errorAdditionalDrivingTimeSecLessOrEqualFourHours
        }
      }
    },
  )

  return (
    <form.DurationInput
      name="additionalDrivingTimeSec"
      disabled={type.field.value !== 'delayed'}
      label={texts.labelAdditionalDrivingTimeSec}
      testId="road-editor-additionalDrivingTime"
    />
  )
}
